export function transformNaNToUndefined(value: number) {
  return isNaN(value) ? undefined : value;
}
